var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.dash.title))]),_c(_vm.currentRole,{tag:"component",attrs:{"dash":_vm.dash}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }